export const getApiErrorMessage = (error, fallback = "Error desconocido") => {
    if (!error) return fallback;
    if (typeof error === "string") return error;

    const data = error?.data || error?.response?.data;
    if (data) {
        if (typeof data === "string") return data;
        if (data.message) return data.message;
        if (data.msg) return data.msg;
        if (data.error) {
            return typeof data.error === "string" ? data.error : JSON.stringify(data.error);
        }
    }

    return error.message || fallback;
};
